'use client'

import { XIcon } from '@phosphor-icons/react'

import { Drawer } from '@/components/primitives/Drawer/Drawer'
import { cn } from '@/lib/utils'

import FormRenderer from '../Forms/FormRenderer'

import type { JSX } from 'react'

export const EnquireDrawer = ({ children, formSrc }: { children: JSX.Element; formSrc: string }) => {
  return (
    <Drawer direction="right" aria-label="Sort">
      <Drawer.Trigger>{children}</Drawer.Trigger>
      <Drawer.Content className={'no-scrollbar relative bottom-0 left-0 h-full overflow-y-auto overflow-x-hidden rounded-l-xl bg-grey-100'}>
        <div className={cn('flex h-full flex-1 flex-col justify-between duration-200')}>
          <Drawer.Header className="relative bg-white px-6 py-5">
            <div className={cn('flex items-center justify-start')}>
              <h3 className="text-lg font-semibold capitalize">Enquire</h3>
              <Drawer.Close>
                <XIcon size={24} className="absolute right-6 top-[22px] cursor-pointer text-grey-500" />
              </Drawer.Close>
            </div>
          </Drawer.Header>

          <Drawer.Body className="relative mt-2 flex flex-1 flex-col  overflow-y-auto bg-white px-4 py-5 lg:p-6">
            <FormRenderer src={formSrc} type="drawer" />
          </Drawer.Body>
        </div>
      </Drawer.Content>
    </Drawer>
  )
}
